import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  /* background-color:crimson; */
  h1 {
    letter-spacing: 1px;
    text-align: center;
    margin: 1.5em 1em 2em 1em;
    font-size: 2rem;
    @media (max-width: 768px) {
      font-size: 1.2rem;
    }
  }
  label,
  span {
    display: inline-block;
    font-size: 1.2rem;
    width: 25%;
    font-weight: 600;
    color: #000;
    padding: 20px;
    border-bottom: 1px solid #e0e0e0;
    @media (max-width: 1024px) {
      font-size: 1rem;
      width: 30%;
      font-weight: 400;
      padding: 10px;
    }
  }
  input {
    background: #e8f0f7;
    /* background: rgba(0,0,0,0.3); */
    border: none;
    outline: none;
    width: 40%;
    font-size: 1.2rem;
    padding: 20px;
    color: rgba(0, 0, 0);
    border-radius: 5px;
    @media (max-width: 1024px) {
      font-size: 1rem;
      font-weight: 400;
      padding: 10px;
    }
  }
`
export const Button = styled.button`
  display: flex;
  width: 30%;
  justify-content: center;
  padding: 0.75rem 1rem;
  border-radius: 5px;
  font-weight: bold;
  background: #2d60ff;
  color: white;
  border: none;
  cursor: pointer;
  font-size: 1rem;
  padding: 20px;
  margin: 4rem auto;
  @media (max-width: 768px) {
    width: 90%;
  }
`

export const Icon = styled.div`
  width: 3%;
  @media (max-width: 768px) {
    display: none;
  }
`

export const Div = styled.div`
  width: 95%;
  gap: 0.5rem;
  margin: 0.5rem auto;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 768px) {
    width: 100%;
  }
`
export const Details = styled.div`
  list-style-type: circle;
  margin: 0 auto 0 auto;
  display: flex;
  justify-content: center;
  font-size: 24px;
  cursor: pointer;
  padding: 2rem;
  text-decoration: underline;
`
